import { render } from "./ProjectInfo.vue?vue&type=template&id=65937274"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__